import { Action } from 'redux';

import { AssetListItem } from '../../../ts/ServerApi/types/AssetListItem';
import { UpdateAssetListItems } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface UpdateAssetListItemsAction extends Action {
  items: AssetListItem[];
}

export function updateAssetListItems(items: AssetListItem[]) {
  return {
    type: UpdateAssetListItems,
    items,
  };
}

export const isUpdateAssetListItemsAction = isActionFactory<UpdateAssetListItemsAction>(UpdateAssetListItems);
